import { useEffect, useState } from "react";
import clsx from "clsx";
import { loadStayCalendarNotes, type StayCalendarNote } from "@/lib/stayCalendarNotes";

export function StayCalendarNotes({
  arrivalDate,
  departureDate,
}: {
  arrivalDate: string | null | undefined;
  departureDate: string | null | undefined;
}) {
  const [notes, setNotes] = useState<StayCalendarNote[]>([]);

  useEffect(() => {
    if (!arrivalDate || !departureDate) {
      setNotes([]);
      return;
    }
    let cancelled = false;
    loadStayCalendarNotes(arrivalDate, departureDate)
      .then((next) => {
        if (!cancelled) setNotes(next);
      })
      .catch(() => {
        if (!cancelled) setNotes([]);
      });
    return () => {
      cancelled = true;
    };
  }, [arrivalDate, departureDate]);

  if (notes.length === 0) return null;

  return (
    <ul className="mt-2 flex flex-col gap-1">
      {notes.map((note) => (
        <li
          key={note.id}
          className={clsx(
            "inline-flex w-fit max-w-full items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium",
            note.kind === "holiday"
              ? "bg-status-orange/15 text-status-orange"
              : "bg-accent-soft text-accent",
          )}
        >
          <span>{note.kind === "holiday" ? "Feiertag" : "Veranstaltung"}</span>
          <span className="truncate font-semibold text-label">{note.title}</span>
        </li>
      ))}
    </ul>
  );
}
